import React from 'react'
import { injectIntl } from 'react-intl'
import messages from '../translate'
import WidgetContainer from '../../WidgetContainer'
import LogTable from './LogTable'

function SiteLogHistory(props) {
  const {
    intl: { formatMessage },
  } = props

  return (
    <WidgetContainer
      name={formatMessage(messages.historyLogbook)}
      className="log-table">
      <LogTable isStateCriteria />
    </WidgetContainer>
  )
}

export default injectIntl(SiteLogHistory)
